import Rebase from 're-base';
import firebase from 'firebase'

const app = firebase.initializeApp({
  apiKey: "AIzaSyDAFkHjtnu-fZerFLFY1GJLL6a8z3Xk8O8",
  authDomain: "guardian-loadouts.firebaseapp.com",
  databaseURL: "https://guardian-loadouts.firebaseio.com",
  projectId: "guardian-loadouts",
  storageBucket: "guardian-loadouts.appspot.com",
  messagingSenderId: "471559438264"
});

const base = Rebase.createClass(app.database());


export default base;


// WEBPACK FOOTER //
// ./src/base.js